import { createFileRoute } from '@tanstack/react-router'
import { CalendarView } from '@/features/service/calendar-view'
import { requireFlow } from '@/features/auth/guards'

export const Route = createFileRoute('/_authenticated/service/calendar')({
  beforeLoad: requireFlow('service'),
  component: CalendarView,
})
